module.exports = "/_next/static/images/search-on-the-go-es-daf698d60df3a620f0ab68d5b3dc5a56.jpg";